module.exports = __webpack_public_path__ + "static/media/Rubik-BoldItalic.8ca6c4d0.ttf";